// @ts-check

import { getAll } from "../utilities/querySelector";

document.addEventListener( 'DOMContentLoaded', function() {
    initChoiceMakers( 'range' );
    initChoiceMakers( 'vehicle' );
} );

/**
 * @param {string} type
 */
function initChoiceMakers( type ) {
    const choiceMakers = getAll( `[data-${type}-choice]` );
    choiceMakers.forEach( btn => btn.addEventListener( 'click', ( e ) => {
        const choice = btn.getAttribute( `data-${type}-choice` ) || '';
        updateChoice( type, choice );
    } ) );
}


/**
 * @param {string} type
 * @param {string} choice
 */
function updateChoice( type, choice ) {
    const selects = getAll( `[data-select-type="${type}"]` );
    selects.forEach( select => {
        const option = select.querySelector( `[value="${choice}"]` );
        select.value = option?.value;
        select.dispatchEvent( new Event( 'input' ) );
    } );
}


const depotChoiceMakers = getAll( '[data-depot-choice]' );
depotChoiceMakers.forEach( btn => btn.addEventListener( 'click', ( e ) => {
    const choice = e.currentTarget.dataset.depotChoice;
    updateDepotChoice( choice );
} ) );

function updateDepotChoice( choice ) {
    const options = getAll( `[data-depot-select] option[data-depot-label="${choice}"]` );
    options.forEach( option => {
        const siblings = option.parentElement?.children ?? [];
        for ( const child of siblings ) {
            if ( child === option ) child.setAttribute( 'selected', '' );
            else child.removeAttribute( 'selected' );
        }
    } );
}


const jobChoiceMakers = getAll( '[data-select-vacancy-option]' );
jobChoiceMakers.forEach( btn => btn.addEventListener( 'click', ( e ) => {
    const choice = e.currentTarget.getAttribute( 'data-select-vacancy-option' );
    let validDepots = e.currentTarget.getAttribute( 'data-depots' ) || '[]';
    validDepots = JSON.parse( validDepots );
    updateJobChoice( choice );
    restrictDepotDropdown( validDepots );
} ) );

function updateJobChoice( choice ) {
    const selects = getAll( `select[data-job-select]` );
    selects.forEach( select => {
        const matchedOption = select.querySelector( `[data-vacancy-option-id="${choice}"]` );
        select.value = matchedOption.value;
    } );
}

/**
 * @param {string[]} validDepots An array of valid depot labels
 */
function restrictDepotDropdown( validDepots ) {
    const jobApplyForm = document.querySelector( '.modal-job-apply' );
    const options = jobApplyForm?.querySelectorAll( 'option[data-depot-label]' );

    if ( validDepots.length === 0 ) {
        options?.forEach( option => {
            option.removeAttribute( 'disabled' );
        } );
        return;
    }

    options?.forEach( option => {
        const depotName = option.getAttribute( 'data-depot-label' ) || '';
        option.toggleAttribute( 'disabled', !validDepots.includes( depotName ) );
    } );
}

document.addEventListener( 'DOMContentLoaded', function() {
    const dateInputs = document.querySelectorAll( 'input[type="date"][name="your-date1"], input[type="date"][name="your-date2"], input[type="date"][name="your-date3"]' );

    dateInputs.forEach( function( input ) {
        input.addEventListener( 'change', function( event ) {
            const date = new Date( event.target.value );
            const day = date.getDay();

            if ( day === 0 || day === 6 ) {
                alert( 'Weekends are not selectable. Please choose a weekday.' );
                event.target.value = '';
            }
        } );
    } );
} );
